module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-wind.png?51fb987571d4f6f5f09e889edd065d22";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-wind.png
// module id = 1054
// module chunks = 1